import React, { useEffect, useState } from 'react';
import Sidebar from './Sidebar';
import Topbar from './Topbar';
import useIsDesktop from '../hooks/useIsDesktop';

const THEME_KEY = 'rental-ace-theme';

function getInitialTheme() {
  const stored = localStorage.getItem(THEME_KEY);
  if (stored === 'light' || stored === 'dark') return stored;
  return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
}

function AppShell({
  navGroups,
  activeKey,
  onNavigate,
  badgeCounts,
  userName,
  userRole,
  onLogout,
  pageTitle,
  breadcrumb,
  searchPlaceholder,
  searchValue,
  onSearchChange,
  notificationCount,
  onNotificationsClick,
  children,
}) {
  const isDesktop = useIsDesktop();
  const [collapsed, setCollapsed] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [theme, setTheme] = useState(getInitialTheme);

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);
    localStorage.setItem(THEME_KEY, theme);
  }, [theme]);

  useEffect(() => {
    if (isDesktop) setMobileOpen(false);
  }, [isDesktop]);

  function toggleTheme() {
    setTheme((t) => (t === 'dark' ? 'light' : 'dark'));
  }

  const sidebarWidth = isDesktop ? (collapsed ? 72 : 240) : 0;

  return (
    <div style={styles.shell}>
      <Sidebar
        navGroups={navGroups}
        activeKey={activeKey}
        onNavigate={(key) => {
          onNavigate(key);
          setMobileOpen(false);
        }}
        badgeCounts={badgeCounts}
        collapsed={collapsed}
        onToggleCollapse={() => setCollapsed((c) => !c)}
        userName={userName}
        userRole={userRole}
        onLogout={onLogout}
        theme={theme}
        onToggleTheme={toggleTheme}
        mobileOpen={mobileOpen}
        onCloseMobile={() => setMobileOpen(false)}
      />

      <div style={{ ...styles.main, marginLeft: `${sidebarWidth}px` }}>
        <Topbar
          pageTitle={pageTitle}
          breadcrumb={breadcrumb}
          onOpenMobileMenu={() => setMobileOpen(true)}
          searchPlaceholder={searchPlaceholder}
          searchValue={searchValue}
          onSearchChange={onSearchChange}
          notificationCount={notificationCount}
          onNotificationsClick={onNotificationsClick}
          theme={theme}
          onToggleTheme={toggleTheme}
        />
        <div style={styles.content}>{children}</div>
      </div>
    </div>
  );
}

const styles = {
  shell: {
    minHeight: '100vh',
    backgroundColor: 'var(--color-bg)',
    fontFamily: 'var(--font-sans)',
  },
  main: {
    minHeight: '100vh',
    transition: 'margin-left 0.2s ease',
  },
  content: {
    maxWidth: '1400px',
    margin: '0 auto',
    padding: '24px',
    boxSizing: 'border-box',
  },
};

export default AppShell;
